import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	configureFields: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	findField: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moreActions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moreActionsIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moreActionsIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	configureFields: {
		id: 'issue-create.modal.create-form.actions-container.dropdown-menu.configure-fields',
		defaultMessage: 'Configure fields',
		description: 'Label for configure fields menu item in issue-create modal header',
	},
	findField: {
		id: 'issue-create.modal.create-form.actions-container.dropdown-menu.find-field',
		defaultMessage: 'Find your field',
		description: 'Label for find field menu item in issue-create modal header',
	},
	moreActions: {
		id: 'issue-create.modal.create-form.actions-container.dropdown-menu.more-actions',
		defaultMessage: 'More actions for this issue',
		description: 'Aria-label for more actions button in issue-create modal',
	},
	moreActionsIssueTermRefresh: {
		id: 'issue-create.modal.create-form.actions-container.dropdown-menu.more-actions-issue-term-refresh',
		defaultMessage: 'More actions for this work item',
		description: 'Aria-label for more actions button in issue-create modal',
	},
	moreActionsIssueTerminologyRefreshM4: {
		id: 'issue-create.modal.create-form.actions-container.dropdown-menu.more-actions-issue-terminology-refresh-m4',
		defaultMessage: 'More actions for this {issueType}',
		description:
			'Aria-label for more actions button in issue-create modal. Please translate as “work type {issueType}”',
	},
});
export default messages;
